
import Vue from "vue"
import throttle from "lodash/throttle"
import { mapState, mapGetters, mapActions } from "vuex"

const MAX_PER_NOM = 1

export default Vue.extend({
  props: {
    nominant: { type: Object, required: true },
    isTest: { type: Boolean, required: false },
  },

  data: () => ({
    btnHover: false,
  }),

  computed: {
    ...mapState("app", ["votingClosed"]),
    ...mapState("user", ["likedNominants"]),
    ...mapGetters("user", ["likedNominantsByNom"]),

    total (): number {
      return 0
    },

    icon (): string {
      if (this.liked) {
        if (this.btnHover) return "heart-broken"
        return "favorite"
      }
      return "favorite-outline"
    },

    totalSplitted (): string {
      const { total } = this
      if (total) return this.total.toLocaleString()
      return ""
    },

    normalizedNominant (): any {
      return this.likedNominants.find((n: any) => n.id === this.nominant.id)
    },

    liked (): boolean {
      return Boolean(this.normalizedNominant)
    },

    limitReached (): boolean {
      const currNom =
        this.likedNominantsByNom[this.nominant.nomination.title.current]
      return (currNom || []).length >= MAX_PER_NOM
    },
  },

  methods: {
    ...mapActions("user", ["likeNominant", "unlikeNominant"]),

    onClick: throttle(async function (this: any) {
      if (!this.$auth.loggedIn) {
        this.$router.push("/auth/login")
      } else if (this.liked) {
        await this.unlikeNominant(this.normalizedNominant)
      } else if (this.limitReached) {
        this.$notify({
          type: "error",
          title: "Голосование",
          message: "Вы уже проголосовали в этой номинации",
        })
      } else {
        this.$notify({
          type: "success",
          title: "Голосование",
          message: "Спасибо! Ваш голос принят!",
        })
        await this.likeNominant(this.nominant)
      }
    }, 1000),
  },
})
